// Insecure quick hash.  Takes string and returns 32-bit integer as hex string.
// Collision is possible, but should be unlikely enough to be treated as unique for React keys.
export const quickHash = (s: string): string =>
    (
        s
            .split("")
            .reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0) >>> 0
    ).toString(16)
